export const TOKEN_COOKIE_NAME = 'userToken';
export const NAV_DEFAULT_VISIBLE_COUNT = 3;
